// components/customer/CustomerOverviewSection.jsx
import { useFormContext, Controller } from "react-hook-form";

// In-house components
import FormCard from "@/components/formInputFields/FormCard";
import FormInput from "@/components/formInputFields/FormInput";
import FormCheckbox from "@/components/formInputFields/FormCheckbox";
import FormPhoneInput from "@/components/formInputFields/FormPhoneInput";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";

export default function CustomerOverviewSection() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormCard className="w-full max-w-3xl">
      <FormSectionTitle>Customer overview</FormSectionTitle>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {/* First name */}
        <FormInput
          label="First name"
          name="firstName"
          placeholder="First name"
          register={register}
          error={errors?.firstName}
        />

        {/* Last name */}
        <FormInput
          label="Last name"
          name="lastName"
          placeholder="Last name"
          register={register}
          error={errors?.lastName}
        />
      </div>

      {/* Email */}
      <FormInput
        label="Email"
        name="email"
        type="email"
        placeholder="Email address"
        register={register}
        error={errors?.email}
      />

      {/* Phone number */}
      <Controller
        name="defaultAddress.phone"
        control={control}
        rules={{ required: "Phone number is required" }}
        render={({ field }) => (
          <FormPhoneInput
            label="Phone"
            {...field}
            error={errors?.phone}
          />
        )}
      />

      <div className="mt-6 space-y-3 border-t border-[#E4E4E4] pt-4">
        <FormCheckbox
          label="Customer agreed to receive marketing emails."
          name="marketingEmailOptIn"
          register={register}
          error={errors?.marketingEmailOptIn}
        />

        <FormCheckbox
          label="Customer agreed to receive SMS marketing text messages."
          name="marketingSmsOptIn"
          register={register}
          error={errors?.marketingSmsOptIn}
        />

        <div>
            <span className="text-[14px] text-[#333333aa] font-medium">
              You should ask your customers for permission before you subscribe them to your marketing emails or SMS.
            </span>
        </div>
        
      </div>
    </FormCard>
  );
};